@if (layoutService.config.settings.icon === 'stroke-svg') {
<svg class="stroke-icon">
  <use attr.xlink:href="assets/svg/icon-sprite.svg#stroke-{{icon}}"></use>
</svg>
} @else {
<svg class="fill-icon">
  <use attr.xlink:href="assets/svg/icon-sprite.svg#fill-{{icon}}"></use>
</svg>
}